module.exports = __webpack_public_path__ + "media/activity/star-empty-804b947b.svg";